import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if Hotjar is initialized
    if (window.hj) {
      // Trigger Hotjar pageview
      window.hj("stateChange", location.pathname);
      console.log("Hotjar tracking page:", location.pathname);
    }
  }, [location]);

  return null;
};

export default RouteChangeTracker;
